const PANEL_SELECTOR = '.mega-panel';
const SIDE_SELECTOR = '.mega-side';
const LINK_SELECTOR = '.mega-link';

/**
 * For each mega-menu panel that has a side preview column (.mega-side),
 * swap that column's content to the description of whichever .mega-link
 * is currently hovered or focused. When no link is being hovered/focused,
 * the panel shows its original "default" content.
 *
 * Per-link copy lives in data-preview-title / data-preview-body on each
 * .mega-link in the partial. The default copy lives in the partial as the
 * initial .mega-side markup.
 */
export function initMegaPreview() {
  const panels = document.querySelectorAll(PANEL_SELECTOR);
  if (panels.length === 0) return;

  panels.forEach((panel) => {
    const side = panel.querySelector(SIDE_SELECTOR);
    if (!side) return;

    const defaultHTML = side.innerHTML;
    const links = panel.querySelectorAll(LINK_SELECTOR);

    const showPreview = (link) => {
      const title = link.dataset.previewTitle;
      const body = link.dataset.previewBody;
      if (!title || !body) return;

      const titleEl = document.createElement('div');
      titleEl.className = 'mega-col-title';
      titleEl.textContent = `// ${title}`;

      const bodyEl = document.createElement('p');
      bodyEl.className = 'mega-blurb';
      bodyEl.textContent = body;

      side.innerHTML = '';
      side.appendChild(titleEl);
      side.appendChild(bodyEl);
    };

    const restoreDefault = () => {
      side.innerHTML = defaultHTML;
    };

    links.forEach((link) => {
      link.addEventListener('mouseenter', () => showPreview(link));
      link.addEventListener('focusin', () => showPreview(link));
      link.addEventListener('mouseleave', restoreDefault);
      link.addEventListener('focusout', restoreDefault);
    });
  });
}
